import { render } from "./editApply.vue?vue&type=template&id=5706d4ab&scoped=true"
import script from "./editApply.vue?vue&type=script&lang=js"
export * from "./editApply.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5706d4ab"]])

export default __exports__